import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components';
export var LicenseUpdateType;
(function (LicenseUpdateType) {
    LicenseUpdateType["Online"] = "Online";
    LicenseUpdateType["Offline"] = "Offline";
})(LicenseUpdateType || (LicenseUpdateType = {}));
var UpdateModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateModalComponent, _super);
    function UpdateModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdateModalComponent.prototype.online = function () {
        this._dialogRef.close({
            type: 2 /* Update */,
            additionalData: LicenseUpdateType.Online,
        });
    };
    UpdateModalComponent.prototype.offline = function () {
        this._dialogRef.close({
            type: 2 /* Update */,
            additionalData: LicenseUpdateType.Offline,
        });
    };
    return UpdateModalComponent;
}(UiModalComponent));
export { UpdateModalComponent };
